import {EventEmitter, Injectable} from '@angular/core';
import {NavigationService} from "./navigation.service";

@Injectable({
  providedIn: 'root'
})
export class MainTabsService {
  private tabsNames = {
    deposit: 'deposit',
    redeem: 'redeem',
    login: 'login'
  };
  private activeTab = null;
  updateActiveTab = new EventEmitter<string>();

  constructor(private navigationService: NavigationService,) {}

  makeRedeemTabActive() {
    this.navigationService.goToHomePage();
    this.activeTab = this.tabsNames.redeem;
    this.updateActiveTab.emit(this.tabsNames.redeem);
  }

  isRedeemTabActive(): boolean {
    return this.activeTab === this.tabsNames.redeem;
  }

  makeDepositTabActive() {
    this.navigationService.goToHomePage();
    this.activeTab = this.tabsNames.deposit;
    this.updateActiveTab.emit(this.tabsNames.deposit);
  }

  isDepositTabActive(): boolean {
    return this.activeTab === this.tabsNames.deposit;
  }

  makeLoginTabActive() {
    this.activeTab = this.tabsNames.login;
    this.updateActiveTab.emit(this.tabsNames.login);
  }

  isLoginTabActive(): boolean {
    return this.activeTab === this.tabsNames.login;
  }

  resetActiveTab() {
    this.activeTab = null;
    this.updateActiveTab.emit('noActive');
  }

  isNoTabsActive(): boolean {
    return this.activeTab === null;
  }
}
